import { Payment } from "./payment";
import { PeriodicProduct } from "./periodic-product";
import {PAYMENT_VALIDATION_STATUS_PENDING, PAYMENT_VALIDATION_STATUS_VALIDATION} from "../constants";

export interface PeriodicProductPayment {
  product: PeriodicProduct;
  payments: Payment[];
  isApplicable: boolean;
  isPastDue: boolean;
  totalPriceToPay: number;
  remainingPriceToPay: number;
  manualCheckStatusId: string | null;
  isCompleted: boolean;
}

export interface MemberProductStatus {
  productId: string;
  product: PeriodicProduct;
  productName: string;
  payments: MemberProductPayment[];
  isCompleted: boolean;
  isPastDue: boolean;
  manualCheckStatusId: string | null;

  originalPrice: number;
  paidAmount: number;
  remainingPrice: number;
}

export interface MemberProductPayment {
  paymentDetailId: string;
  paymentDate: Date;
  paymentMethod: string;
  amount: number;
}

export const isInVerificationProcess = (product: MemberProductStatus): boolean => product.manualCheckStatusId === PAYMENT_VALIDATION_STATUS_PENDING || product.manualCheckStatusId === PAYMENT_VALIDATION_STATUS_VALIDATION;
